import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
	name: 'filterBy',
	pure: true
})
export class FilterByPipe implements PipeTransform {
	transform(arr: Array<any>, fieldName: any, value: string): any {
		
		return arr.filter(function (item) {
			return item[fieldName] === value;
		});
	};
}
